import { render, staticRenderFns } from "./Dotsandboxes.vue?vue&type=template&id=2ea70b30&"
import script from "./Dotsandboxes.vue?vue&type=script&lang=js&"
export * from "./Dotsandboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports